// @flow

import React from 'react';
import { withTranslation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import FacebookLogin from './facebook-login';
import ManualApply from './manual-apply';
import { ApiClient } from '../api/apply-page-api-client';
import { WebRoutes } from '../apply-routes';
import { withApplyContext } from '../with-apply-context';

const styles = theme => ({
  container: {
    width: '97%',
    margin: 'auto',
  },
});

type Props = CoreApplyProps & {
  jobHash: string,
  classes: Object,
  t: (value: string, opts?: any) => string,
}

class ApplyOptions extends React.PureComponent<Props> {
  apply = async (applicant: Applicant) => {
    const { visitId, jobHash, source, sourceId } = this.props;
    if (!visitId) {
      return;
    }
    const result = await ApiClient.apply(jobHash, source, sourceId, visitId, applicant);
    window.location = WebRoutes.wizardStart(result.jobApplicationHash);
  };

  referralApply = async () => {
    const { visitId, jobHash, referralHash } = this.props;
    if (!visitId || !referralHash) {
      return;
    }
    const result = await ApiClient.referralApply(jobHash, referralHash, visitId);
    window.location = WebRoutes.wizardStart(result.jobApplicationHash);
  };

  render() {
    const { classes, t } = this.props;
    if (this.props.referralHash) {
      return (
        <Grid container className={classes.container} alignItems="center" justify="center">
          <Grid item>
            <Button
              variant="contained"
              onClick={this.referralApply}
              color="secondary"
              disabled={this.props.visitId === null}
            >
              {t('applyNow')}
            </Button>
          </Grid>
        </Grid>
      );
    }
    return (
      <Grid container className={classes.container} alignItems="center" justify="center" spacing={2}>
        <Grid item xs={12} sm={4}>
          <ManualApply applyCallback={this.apply} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <FacebookLogin applyCallback={this.apply} />
        </Grid>
      </Grid>
    );
  }
}

export default withTranslation()(withApplyContext(withStyles(styles)(ApplyOptions)));
